type Level = 'debug' | 'log' | 'warn' | 'error';

interface ILogger {
  error: LogFunction;
  warn: LogFunction;
  log: LogFunction;
  debug: LogFunction;
}

export interface LogFunction {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (message?: any, ...optionalParams: any[]): void;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const nullLog: LogFunction = (_?: any, ...__: any[]) => {};

class Logger implements ILogger {
  error: LogFunction = console.error.bind(console);
  warn: LogFunction = console.warn.bind(console);
  log: LogFunction = console.log.bind(console);
  debug: LogFunction = console.debug.bind(console);

  constructor(level: Level) {
    this.setLevel(level);
  }

  setLevel(level: Level) {
    // first rebind all
    this.error = console.error.bind(console);
    this.warn = console.warn.bind(console);
    this.log = console.log.bind(console);
    this.debug = console.debug.bind(console);
    // then override to null those not required
    switch (level) {
      case 'error':
        this.warn = nullLog;
        this.log = nullLog;
        this.debug = nullLog;
        break;
      case 'warn':
        this.log = nullLog;
        this.debug = nullLog;
        break;
      case 'log':
        this.debug = nullLog;
        break;
    }
    this.debug(`logger.setLevel: ${level}`);
  }
}

let logLevel: Level = 'warn';

export const setLogLevel = (level: Level): void => {
  logLevel = level;
  logger.setLevel(logLevel);
};

export const logger = new Logger(logLevel);

/**
 * Enable our log level to be set in Developer Tools javascript console.
 * This is a 'private' way to enable debug logging - versus setting console level.
 * However, it is overridden on page reload (e.g. login redirect)
 */
declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setLogLevel?: any;
  }
}
window.setLogLevel = setLogLevel;
